import { getAreas, getAreaAll, getAreaData, getAreaPolygon, getAreaDetails } from '../../ajax/endpoints';
import {
  addActiveBuildingArea,
  addActiveBuildingAreaPolygon,
  addBuildingAreaDetails,
  addBuildingAreaReport,
  addActiveSiteArea,
  addActiveSiteAreaPolygon,
  addSiteAreaDetails,
  addSiteAreaReport,
} from '../actions';
import { PROPERTY_TYPES } from '../../constants';

export function loadingAreas(layer, loading) {
  return {
    type: `LOADING_${layer.toUpperCase()}`,
    layer,
    loading,
  };
}

export function addAreas(layer, areas) {
  return {
    type: `ADD_${layer.toUpperCase()}`,
    areas,
  };
}

export function addActiveArea(area, layer) {
  return {
    type: 'ADD_ACTIVE_AREA',
    area,
    layer,
  };
}

export function addAreaReport(report) {
  return {
    type: 'ADD_AREA_REPORT',
    report,
  };
}

export function addAreaPolygon(layer, id, polygon) {
  return {
    type: `ADD_${layer.toUpperCase()}_POLYGON`,
    layer,
    id,
    polygon,
  };
}

export function addAreaPolygons(layer, areas, polygons) {
  return {
    type: `ADD_${layer.toUpperCase()}_POLYGONS`,
    layer,
    areas,
    polygons,
  };
}

export function addAreaDetails(details) {
  return {
    type: 'ADD_AREA_DETAILS',
    details,
  };
}

export function areaAllData(areasAll) {
  return {
    type: 'AREA_ALL_DATA',
    areasAll,
  };
}

export function fetchAreas(layer, org) {
  return dispatch => {
    dispatch(loadingAreas(layer, true));
    return getAreas(layer, org)
    .then(data => {
      dispatch(addAreas(layer, data));
      dispatch(loadingAreas(layer, false));
      return data;
    });
  };
}

export function fetchAreaAll(org) {
  return dispatch => {
    return getAreaAll(org)
    .then(data => {
      dispatch(areaAllData(data));
      return data;
    });
  };
}

export function fetchAreaPolygon(layer, areas, type = 'areas') {
  let addAreaPolygonSetter = '';
  switch (type) {
    case 'areas':
      addAreaPolygonSetter = addAreaPolygons;
      break;
    case 'buildings':
      addAreaPolygonSetter = addActiveBuildingAreaPolygon;
      break;
    case 'sites':
      addAreaPolygonSetter = addActiveSiteAreaPolygon;
      break;
    default:
      break;
  }
  const areaArray = Array.isArray(areas) ? areas : [areas];
  const idArray = (layer === 'regions')
    // For a region, we want one big outline of all combined counties
    ? areaArray.map(area => area.counties.map(county => county.id).join(','))
    : areaArray.map(area => area.id);
  return dispatch => {
    let promise;
    if (layer === 'regions') {
      promise = Promise.all(areaArray.map(area => {
        const ids = area.counties.map(county => county.id).join(',');
        return getAreaPolygon(layer, [ids])
        .then(polygons => {
          dispatch(addAreaPolygonSetter(layer, [area], polygons));
        });
      }));
    } else {
      promise = getAreaPolygon(layer, idArray)
      .then(polygons => {
        dispatch(addAreaPolygonSetter(layer, areaArray, polygons));
      });
    }
    return promise
    .catch(err => {
      if (process.env.NODE_ENV !== 'test') {
        // eslint-disable-next-line no-console
        console.error(err);
      }
      return [];
    });
  };
}

export function fetchBuildingOrSiteAreas(layer, org, type, location) {
  const activeArea = type === PROPERTY_TYPES.BUILDINGS ? addActiveBuildingArea : addActiveSiteArea;
  return dispatch => {
    return getAreas(layer, org)
    .then(data => {
      let area = {};
      switch (layer) {
        case 'states':
          area = data.find(d => d.state_cd === location.state);
          break;
        case 'regions': {
          area = data.find(d => d.counties.some(county => county.name === location.countyName));
          break;
        }
        case 'counties':
          area = data.find(d => d.intid === location.county);
          break;
        case 'communities':
          area = data.find(d => d.intid === location.community);
          break;
        default:
          break;
      }
      dispatch(activeArea({ [layer]: area }));
      return area;
    });
  };
}

export function fetchAreaData(geo, id, report, type = 'areas', layer) {
  let addAreaReportSetter = '';
  switch (type) {
    case 'areas':
      addAreaReportSetter = addAreaReport;
      break;
    case 'buildings':
      addAreaReportSetter = addBuildingAreaReport;
      break;
    case 'sites':
      addAreaReportSetter = addSiteAreaReport;
      break;
    default:
      break;
  }
  return dispatch => {
    return getAreaData(geo, id, report)
      .then(data => {
        dispatch(addAreaReportSetter({ [report]: data }, layer));
      })
      .catch(err => {
        if (process.env.NODE_ENV !== 'test') {
          // eslint-disable-next-line no-console
          console.error(err);
        }
        return [];
      });
  };
}

export function fetchAreaDetails(layer, area, type = 'areas') {
  let addAreaDetailsSetter = '';
  switch (type) {
    case 'areas':
      addAreaDetailsSetter = addAreaDetails;
      break;
    case 'buildings':
      addAreaDetailsSetter = addBuildingAreaDetails;
      break;
    case 'sites':
      addAreaDetailsSetter = addSiteAreaDetails;
      break;
    default:
      break;
  }
  return dispatch => {
    return getAreaDetails(layer, area)
      .then(details => {
        dispatch(addAreaDetailsSetter(details, layer));
      }).catch(err => {
        if (process.env.NODE_ENV !== 'test') {
          // eslint-disable-next-line no-console
          console.error(err);
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/areas.js